import moment from 'moment';
import { DATE_FORMAT } from '../../../../constants';

export const checkIsAllowedSubmissionWindow = (
  startDate?: string | null,
  endDate?: string,
  bufferDate?: string,
): boolean => {
  if (!startDate || !endDate || !bufferDate) return false;

  const validBufferDate = moment().add(1, 'days').format(DATE_FORMAT);
  const allowedBufferDateForFuture = moment().add(2, 'days').format(DATE_FORMAT);
  const isFutureSeries = checkIsFutureSeries(startDate, endDate, bufferDate);

  return isFutureSeries
    ? moment(bufferDate).format(DATE_FORMAT) >= allowedBufferDateForFuture
    : moment(bufferDate).format(DATE_FORMAT) >= validBufferDate;
};

const checkIsFutureSeries = (startDate: string, endDate: string, bufferDate: string): boolean => {
  const today = moment();
  const isFutureStartDate = moment(startDate).isAfter(today);
  const isFutureEndDate = moment(endDate).isAfter(today);
  const isFutureBufferDate = moment(bufferDate).isAfter(today);

  return isFutureStartDate && isFutureEndDate && isFutureBufferDate;
};
